import { environment } from '../../environments/environment';
import { getLocaleDateFormat } from '@angular/common';
import * as moment from 'moment';

export const SECRET: string = environment.SECRET;
export const TIMER_LEFT = 0;
export const currentTimeStamp = moment().format('x');
export const currentDateTime = moment().format('DD.MM.YYYY HH:mm');
declare global {
  interface Window { stream: any; }
}


export interface faceCompareAuthApi {
  auth_header: any;
  status: string;
}

export const languageList = {
  English: 'English',
  // Hindi: 'हिंदी'
};

/*
*Function to format the date in (DD MMMM, YYYY) format
*@return formatDate
*/
export function dateformat(date: string): string | boolean {
  if (date.length <= 0 && typeof date !== 'string') { return false; }
  const formatDate = moment(date, 'DD-MM-YYYY').format('DD MMMM, YYYY');
  return formatDate;
}

export const answerList = [
  {
    "PIVC_QID": "100001",
    "Answer": "Y"
  },
  {
    "PIVC_QID": "100002",
    "Answer": "Y"
  }
];
